import { gql, useMutation } from '@apollo/client';
import { useEventCallback } from '@mui/material/utils';
import { useTranslation } from 'react-i18next';

import { useDialogs } from '@work4all/components';

import { InputSetMfaMode } from '@work4all/models/lib/Classes/InputSetMfaMode.entity';
import { MfaMode } from '@work4all/models/lib/Enums/MfaMode.enum';

const UPDATE_MFA = gql`
  mutation ResetUserMfaMode($input: InputSetMfaMode!) {
    updateUserMfaMode(input: $input) {
      ok
    }
  }
`;

type ResetUserMfaModeResponse = {
  updateUserMfaMode: { ok: boolean };
};

type ResetUserMfaModeVars = {
  input: InputSetMfaMode;
};

type Props = {
  userCode: number;
  onSuccess?: () => void;
};

export const useResetMfaDialog = ({ userCode, onSuccess }: Props) => {
  const dialogs = useDialogs();
  const { t } = useTranslation();

  const [mutateUpdateMfa] = useMutation<
    ResetUserMfaModeResponse,
    ResetUserMfaModeVars
  >(UPDATE_MFA);

  const reset = useEventCallback(async () => {
    const response = await mutateUpdateMfa({
      variables: { input: { userCode, mfaMode: MfaMode.NORMAL } },
    });

    if (response?.data?.updateUserMfaMode?.ok) onSuccess?.();
  });

  const open = useEventCallback(async () => {
    const confirmed = await dialogs.confirm({
      title: t('RESET_MFA_DIALOG.TITLE'),
      description: t('RESET_MFA_DIALOG.DESCRIPTION'),
      confirmLabel: t('COMMON.RESET'),
      cancelLabel: t('ALERTS.BTN_ABORT'),
    });

    if (confirmed) reset();
  });

  return open;
};
